import { render, staticRenderFns } from "./MessageFormats.vue?vue&type=template&id=1df6edbb&scoped=true&"
import script from "./MessageFormats.vue?vue&type=script&lang=ts&"
export * from "./MessageFormats.vue?vue&type=script&lang=ts&"
import style0 from "./MessageFormats.vue?vue&type=style&index=0&id=1df6edbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6edbb",
  null
  
)

export default component.exports